import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { AlertBanner, ThemeProvider } from '@flowcore-water/ui';
import { AuthGate } from './components/AuthGate';
import { Layout } from './components/Layout';
import { EntityIndex } from './views/EntityIndex';
import { EntityList } from './views/EntityList';
import { RecordDetail } from './views/RecordDetail';
import { GlobalSearch } from './views/GlobalSearch';
import { JoinView } from './views/JoinView';

export default function App() {
  return (
    <ThemeProvider>
      <Sentry.ErrorBoundary
        fallback={({ error }) => (
          <div style={{ padding: 24, maxWidth: 600, margin: '80px auto' }}>
            <AlertBanner
              variant="error"
              message="An unexpected error occurred."
              error={error}
              persistent
              onRetry={() => window.location.reload()}
            />
          </div>
        )}
      >
        <AuthGate>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<EntityIndex />} />
                <Route path="browse/:entity" element={<EntityList />} />
                <Route path="browse/:entity/:id" element={<RecordDetail />} />
                <Route path="search" element={<GlobalSearch />} />
                <Route path="join/:joinKey" element={<JoinView />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthGate>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  );
}
